<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="editStatrgyManagerDialog"
  >
    <statrgy-manager-form
      v-if="dialogShow"
      ref="outform"
      @submit="submit"
    ></statrgy-manager-form>
  </sliderBarDialogShell>
</template>

<script>
import statrgyManagerForm from "@/components/sys/strategyManager/statrgyManagerForm";
import { saveStrategy } from "@/api/sys/statrgyManager/statrgyManager";

export default {
  name: "addStatrgyManagerDialog",
  components: {
    statrgyManagerForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      title: '新增策略 '
    }
  },
  methods: {
    beforeClose() {
      this.$refs.outform.selfClear();
      this.$emit('close');
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      this.$refs.outform.selfValidate();
    },
    submit(form) {
      let params = {
        ...form,
      }
      saveStrategy(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '添加成功',
            type: 'success',
          });
          this.$refs.outform.selfClear();
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      })
    }
  },
}
</script>
<style>
@media screen and (min-width: 768px) {
  .editStatrgyManagerDialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
